export default __webpack_public_path__ + "static/media/perfilPic.afceb672.webp";